import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function NotificationBanner({children, onCloseBanner, imageURL, title}) {
  return (
    <div className="u-flex-display homeSidepanel-notifications">
      <img className="homeSidepanel-notification-icon" src={imageURL} />
      <div className="homeSidepanel-notification-text">
        <a className="homeSidepanel-notification-close close pull-right" onClick={onCloseBanner}>
          <BenchlingIcon icon="close" />
        </a>
        <div className="u-small-spacing-bottom">{title}</div>
        {children}
      </div>
    </div>
  );
}

NotificationBanner.propTypes = {
  children: PropTypes.node.isRequired,
  onCloseBanner: PropTypes.func.isRequired,
  imageURL: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
};
